<template>
  <section class="nav-bars">
    <section-title>NavBars Component</section-title>

    <h3>Nav bar with links</h3>
    <nav-bar>
      <nav-bar-link
        label="Link 1"
        icon="cog"
        to="/playground/ui-elements"
      />

      <nav-bar-link
        label="Link 2"
        icon="bell"
        to="/playground/ui-elements-page2"
      />
    </nav-bar>

    <h3>Nav bar with link on the right</h3>
    <nav-bar>
      <nav-bar-link
        label="Left 1"
        icon="cog"
        to="/playground/ui-elements"
      />

      <nav-bar-link
        icon="bell"
        label="Left 2"
        to="/playground/ui-elements-page2"
      />

      <nav-bar-link
        icon="eye"
        label="Right 1"
        position="right"
        to="/playground/ui-elements-page3"
      />

      <nav-bar-link
        icon="eye"
        label="Right 2"
        position="right"
        to="/playground/ui-elements-page3"
      />
    </nav-bar>

    <h3>Nav bar with dropdown</h3>
    <nav-bar>
      <nav-bar-link
        label="Left 1"
        icon="cog"
        to="/playground/ui-elements"
      />

      <nav-bar-link
        icon="bell"
        label="Left 2"
        to="/playground/ui-elements-page2"
      />

      <nav-bar-dropdown
        :options="options"
        icon="cog"
        label="Click me"
        position="right"
        @select="handleSelect"
      />
    </nav-bar>

    <div v-if="selected">
      Selected: {{ selected.label }}
    </div>
  </section>
</template>

<script>
import NavBarMixin from '@/mixins/ui/NavBar'
import SectionTitle from '@/components/ui/SectionTitle'

export default {
  name: 'NavBars',
  mixins: [NavBarMixin],
  components: {
    SectionTitle
  },
  data () {
    return {
      isVisible: false,
      selected: null
    }
  },
  computed: {
    options () {
      return [
        { label: 'Spiderman', value: 'spiderman', icon: 'copy' },
        { label: 'Hulk', value: 'hulk', icon: 'copy' },
        { label: 'Superman', value: 'superman', icon: 'copy' }
      ]
    }
  },
  methods: {
    handleSelect (selected) {
      this.selected = selected
    },
    handleVisibility (visibility) {
      this.isVisible = visibility
    }
  }
}
</script>

<style lang="sass">
.dropdowns
  padding-bottom: 200px
</style>



// WEBPACK FOOTER //
// src/pages/playground/NavBars.vue